module.exports = __webpack_public_path__ + "img/BlinkArt_Sword8_White.f7c732f1.png";